// Central type lookup

import { cvWorkExperienceType } from "./types/cvWorkExperience";
import { educationDocumentType } from "./types/educationDocument";
import { idCardType } from "./types/idCard";
import { passportType } from "./types/passport";

const TYPES = {
  id_card: idCardType,
  passport_copy: passportType,
  education_document: educationDocumentType,
  cv_work_experience: cvWorkExperienceType,
};

export const getDocumentType = (key) => TYPES[key] ?? null;

export const getSchema = (key) => getDocumentType(key)?.schema ?? null;

export const getLlmExtractionFields = (key) =>
  getDocumentType(key)?.getLlmExtractionFields() ?? [];

export const enrichExtractedJson = (key, json, rawText = "") => {
  const type = getDocumentType(key);
  if (!type) return json || {};
  return type.enrichExtractedJson(json, rawText);
};

export const normalizeExtractedJsonForDocument = (key, json, rawText = "") => {
  const type = getDocumentType(key);
  if (!type) return json || {};
  return type.normalizeExtractedJson(json, rawText);
};

export const validateFieldValue = (key, fieldKey, value) => {
  const type = getDocumentType(key);
  if (!type) return null;
  return type.validateFieldValue(fieldKey, value);
};

export const getFieldDef = (key, fieldKey) => {
  const schema = getSchema(key);
  if (!schema) return null;
  return schema.fields.find((field) => field.key === fieldKey) || null;
};

export const getGroupLabel = (key, groupId) => {
  const schema = getSchema(key);
  if (!schema) return groupId;
  return schema.groups.find((group) => group.id === groupId)?.label || groupId;
};

export const isSupportedFile = (key, file) => {
  const type = getDocumentType(key);
  if (!type) return false;
  return type.isSupportedFile(file);
};

export const buildTableFromExtracted = (key, data) => {
  const type = getDocumentType(key);
  if (!type?.buildTableFromExtracted) return null;
  return type.buildTableFromExtracted(data);
};

export const appendTableToExtractedJson = (key, obj, tableData) => {
  const type = getDocumentType(key);
  if (!type?.appendTableToExtractedJson) return obj;
  return type.appendTableToExtractedJson(obj, tableData);
};

export {
  normalizeExtractedField,
  normalizeExtractedFieldValue,
  resolveExtractedRawValue,
} from "./shared/fieldNormalization";
